import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { debounce } from 'lodash';
import { useHistory } from 'react-router-dom';
import AlertModal from 'web/components/AlertModal';
import { postLoadAdvanceSearch, searchNearbyNeed, guestUserInventroy } from 'redux/actions/postLoad';
import { searchNearbyInventory } from 'redux/actions/postInventory';
import { postInventoryAdvanceSearch } from 'redux/actions/postInventory';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import SearchIcon from 'web/assets/images/search-icon.png';
import './typeahead.scss';

const SearchTypeahead = (props) => {
  const { placeholder, minLength, asyncSearch, filterBy, pageType, toggle, defaulTitle, title, pageName, transparent, focusOnShow, callBack } = props
  const ref = useRef();
  let history = useHistory();

  let milesGet = localStorage.getItem('miles')

  const [modal, setModal] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);

  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  let defaultTxt = defaulTitle;
  if (title) {
    defaultTxt = title.toString();
  }
  if (pageType === 'myOrder') defaultTxt = defaulTitle

  const [defaultState, setDefaultState] = useState(defaultTxt);

  useEffect(() => {
    localStorage.setItem("titleInput", "");
    if (focusOnShow) {
      ref.current.focus();
    }
    if (defaultTxt === '') ref.current.clear();
    setDefaultState(defaultTxt)
  }, [defaultTxt]);

  const [searchResponse, setSearchResponse] = useState({ payload: [], title: '', totalRecods: '' });

  const debouncedSearch = useCallback(debounce(async (query, props) => {
    await handleSearch(query, props);
  }, 500), []);

  const handleSearch = async (query, props) => {
    const { pageType, pageName, callBack } = props
    if (pageName === "myOrder") {
      callBack(query)
    } else if (pageName === "Landing") {
      callBack(query)
    } else {
      if (pageName !== "Landing") {
        let response;
        if (pageType !== 'PostInventory') {
          let data = {
            authId: localStorage.getItem('authId'),
            size: 12,
            number: 0,
            sort: "DESC",
            sortBy: "NEAREST",
            searchBy: query || '',
            miles: '',
            isFilter: false,
            filters: null
          }
          response = await dispatch(searchNearbyNeed(data, token));
          setSearchResponse({ ...searchResponse, title: query })

          if (response.success) {
            setSearchResponse({ payload: [], title: '', totalRecods: '' })
            if (response.data.nearBySearch) {
              const options = response.data.nearBySearch.map((i) => ({
                id: i.id,
                title: i?.palletDetail?.title,
                description: i?.palletDetail?.size,
                zipCode: i?.zipCode,
              }));
              setOptions(options);
              setSearchResponse({ ...searchResponse, payload: response.data.nearBySearch, title: query, totalRecods: response?.data?.totalElements });
            }
          } else if (response.statusCode === 409) {
            setOptions();
            setSearchResponse({ payload: [], title: '', totalRecods: '' })
          } else if (response.statusCode === 401) {
            history.push('./sign-in')
            window.location.reload(false);
          }
        } else {
          let data = {
            authId: localStorage.getItem('authId'),
            size: 12,
            number: 0,
            sort: "DESC",
            sortBy: "NEAREST",
            searchBy: query || '',
            miles: '',
            isFilter: false,
            filters: null
          }
          response = await dispatch(searchNearbyInventory(data, token));
          setSearchResponse({ ...searchResponse, title: query })
          setOptions();
          if (response.success) {
            setSearchResponse({ payload: [], title: '', totalRecods: '' })
            if (response.data.nearBySearch) {
              const options = response.data.nearBySearch.map((i) => ({
                id: i.id,
                title: i?.palletDetail?.title,
                description: i?.palletDetail?.size,
                zipCode: i?.zipCode,
              }));
              setSearchResponse({ ...searchResponse, payload: response.data.nearBySearch, title: query, totalRecods: response?.data?.totalElements });
              setOptions(options);
            }
          } else {
            if (response.statusCode === 401) {
              history.push('./sign-in')
            } else if (response.statusCode === 409) {
              setOptions()
              setSearchResponse({ payload: [], title: '', totalRecods: '' })
            }
          }
        }
      } else {
        let data = {
          size: 20,
          number: 0,
          sort: "DESC",
          searchBy: query || '',
          sortBy: null,
          miles: "",
          isFilter: false,
          filters: null,
        }
        let response = await dispatch(guestUserInventroy(data, token));
        if (response.success) {
          setSearchResponse({ payload: [], title: '', totalRecods: '' })
          if (response.data?.inventorySearch) {
            const options = response.data?.inventorySearch.map((i) => ({
              id: i.id,
              title: i.title.toString(),
              description: i.title.toString()
            }));
            setSearchResponse({ ...searchResponse, payload: response.data?.inventorySearch, title: query, totalRecods: response.data.totalElements });
            setOptions(options);
          }
        } else {
          if (response.statusCode === 409) {
            setOptions()
            setSearchResponse({ payload: [], title: '', totalRecods: '' })
          } else if (response.message === "Unauthorized (Invalid token)") {
            history.push('/sign-in')
            window.location.reload(false);
          }
        }
        if (query)
          callBack(query)
      }
    }
  };
  const [searchText, setSearchText] = useState("")

  return (
    asyncSearch && (
      <>
        <div
          className={`type-ahead-search-input ${transparent ? "search-input-transparent" : ""
            } ${searchText.length > 30 ? "hide-hint" : ""}`}
        >
          <AsyncTypeahead
            ref={ref}
            multiple={false}
            id={Math.random().toString()}
            labelKey="title"
            filterBy={["title", "description", "size", "zipCode"]}
            isLoading={false}
            minLength={minLength}
            onSearch={handleSearch}
            options={options}
            placeholder={placeholder}
            defaultInputValue={defaultState || ""}
            onInputChange={(text) => {
              setSearchText(text)
              // == PAL-1207 FIX START
              if (text === "") {
                const payload = {
                  title: text,
                  pageType: pageType,
                  activePage: pageType,
                  activeSearch: 'Dashboard'
                }
                dispatch({ type: 'SEARCH_INVENTORY', payload })
              }
              // PAL-1207 END 

              if (text) setShowMenu(true);
              else setShowMenu(false);

              setDefaultState(text);
              // handleSearch(text);
              debouncedSearch(text, props)
            }}
            onKeyDown={(event) => {
              if (pageName === "myOrder") {
              } else {
                if (pageName !== "Landing" && defaultState !== "") {
                  if (event.keyCode === 13) {
                    setShowMenu(false);
                    if (milesGet) {
                      let obj = {
                        title: defaultState.toString(),
                        miles: milesGet,
                        nearby: true,
                        pageType: pageType,
                        activePage: pageType,
                        activeSearch: 'Dashboard'
                      }

                      let nearBySelectedPageObj = {
                        nearBySelectedPage: 1,
                      }
                      dispatch({ type: 'NEARBY_PAGINATION', payload: nearBySelectedPageObj })
                      localStorage.setItem('advanceSearch', 'SEARCH_BY');
                      if (pageType === 'PostInventory') {
                        dispatch({ type: 'SEARCH_INVENTORY', payload: obj })

                        history.push({
                          pathname: "/nearby-inventory",
                          pageType: "PostInventory"
                        });
                      } else {
                        dispatch({ type: 'SEARCH_POST', payload: obj })

                        history.push({
                          pathname: "/nearby-needs",
                          pageType: "PostLoad"
                        });
                      }
                    } else {
                      let obj = {
                        title: defaultState.toString(),
                        pageType: pageType,
                        activePage: pageType,
                        activeSearch: 'Dashboard'
                      }

                      let nearBySelectedPageObj = {
                        nearBySelectedPage: 1,
                      }
                      dispatch({ type: 'NEARBY_PAGINATION', payload: nearBySelectedPageObj })

                      localStorage.setItem('advanceSearch', 'SEARCH_BY');
                      if (pageType === 'PostInventory') {
                        dispatch({ type: 'SEARCH_INVENTORY', payload: obj })

                        history.push({
                          pathname: "/nearby-inventory",
                          pageType: pageType,
                        });
                      } else {
                        dispatch({ type: 'SEARCH_POST', payload: obj })
                        history.push({
                          pathname: "/nearby-needs",
                          pageType: pageType,
                        });
                      }
                    }
                  }
                } else {
                }
              }
              _.isFunction(toggle) && toggle();
            }
            }
            onChange={(event) => {
              if (event.length !== 0 && event[0].title) {
                // handleSearch(event[0].title.toString());
                debouncedSearch(event[0].title.toString(), props)
                setDefaultState(event[0].title);
                if (pageName === "myOrder") {
                } else {
                  if (pageName !== "Landing" && event.keyCode !== 13) {
                    if (milesGet) {
                      let obj = {
                        title: event[0].title.toString(),
                        miles: milesGet,
                        nearby: true,
                        pageType: pageType,
                        activePage: pageType,
                        activeSearch: 'Dashboard'
                      }

                      let nearBySelectedPageObj = {
                        nearBySelectedPage: 1,
                      }
                      dispatch({ type: 'NEARBY_PAGINATION', payload: nearBySelectedPageObj })

                      localStorage.setItem('advanceSearch', 'SEARCH_BY');
                      if (pageType === 'PostInventory') {
                        dispatch({ type: 'SEARCH_INVENTORY', payload: obj })

                        history.push({
                          pathname: "/nearby-inventory",
                          pageType: "PostInventory"
                        });
                      } else {
                        dispatch({ type: 'SEARCH_POST', payload: obj })
                        history.push({
                          pathname: "/nearby-needs",
                          pageType: pageType,
                        });
                      }
                    } else {
                      let obj = {
                        title: event[0].title.toString(),
                        pageType: pageType,
                        activePage: pageType,
                        activeSearch: 'Dashboard'
                      }

                      let nearBySelectedPageObj = {
                        nearBySelectedPage: 1,
                      }
                      dispatch({ type: 'NEARBY_PAGINATION', payload: nearBySelectedPageObj })

                      localStorage.setItem('advanceSearch', 'SEARCH_BY');
                      if (pageType === 'PostInventory') {
                        dispatch({ type: 'SEARCH_INVENTORY', payload: obj })

                        history.push({
                          pathname: "/nearby-inventory",
                          pageType: pageType,
                        });
                      } else {
                        dispatch({ type: 'SEARCH_POST', payload: obj })

                        history.push({
                          pathname: "/nearby-needs",
                          pageType: pageType,
                        });
                      }
                    }
                  }
                }
              }
              _.isFunction(toggle) && toggle();
              setShowMenu(false)
            }}
            open={showMenu}
            onBlur={() => showMenu && setShowMenu(false)}
            renderMenuItemChildren={(option) => <span>{option[filterBy]}</span>}
          />

          <div
            className="seacrh-icon"
            onClick={(event) => {
              if (searchResponse.title) {
                handleSearch(searchResponse.title.toString());
                setDefaultState(searchResponse.title.toString());
                if (pageName === "myOrder") {
                  callBack(defaultState);
                } else {
                  if (pageName !== "Landing") {
                    if (milesGet) {
                      let obj = {
                        title: searchResponse.title.toString(),
                        miles: milesGet,
                        nearby: true,
                        pageType: pageType,
                        activePage: pageType,
                        activeSearch: 'Dashboard'
                      }


                      let nearBySelectedPageObj = {
                        nearBySelectedPage: 1,
                      }
                      dispatch({ type: 'NEARBY_PAGINATION', payload: nearBySelectedPageObj })
                      localStorage.setItem('advanceSearch', 'SEARCH_BY');
                      if (pageType === 'PostInventory') {
                        dispatch({ type: 'SEARCH_INVENTORY', payload: obj })
                        history.push({
                          pathname: "/nearby-inventory",
                          pageType: pageType,
                        });
                      }
                      else {
                        dispatch({ type: 'SEARCH_POST', payload: obj })

                        history.push({
                          pathname: "/nearby-needs",
                          pageType: pageType,
                        });
                      }
                    } else {
                      let obj = {
                        title: searchResponse.title.toString(),
                        pageType: pageType,
                        activePage: pageType,
                        activeSearch: 'Dashboard'
                      }


                      let nearBySelectedPageObj = {
                        nearBySelectedPage: 1,
                      }
                      dispatch({ type: 'NEARBY_PAGINATION', payload: nearBySelectedPageObj })
                      localStorage.setItem('advanceSearch', 'SEARCH_BY');
                      if (pageType === 'PostInventory') {
                        dispatch({ type: 'SEARCH_INVENTORY', payload: obj })
                        history.push({
                          pathname: "/nearby-inventory",
                          pageType: pageType,
                        });
                      }
                      else {
                        dispatch({ type: 'SEARCH_POST', payload: obj })

                        history.push({
                          pathname: "/nearby-needs",
                          pageType: pageType,
                        });
                      }
                    }
                    window.location.reload(false);
                  } else {
                    callBack()
                  }
                }
              }

            }}
          >
            <img src={SearchIcon} alt="SearchIcon" />
          </div>
        </div>
        {pageName !== "Landing" && (
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title=""
            content={modalContent}
            link={modalLink}
          />
        )}
      </>
    )
  );
};

SearchTypeahead.propTypes = {
  placeholder: PropTypes.string,
  minLength: PropTypes.number,
  asyncSearch: PropTypes.bool,
  searchUrl: PropTypes.string,
  focusOnShow: PropTypes.bool,
  background: PropTypes.string,
  color: PropTypes.string,
};

SearchTypeahead.defaultProps = {
  placeholder: '',
  minLength: 1,
  asyncSearch: true,
  /**
   * @todo : SearchUrl and filterBy should be empty, this needs to be refactored after search api integration
   */
  searchUrl: 'https://api.github.com/search/users',
  filterBy: 'login',
  transparent: false,
  focusOnShow: true,
};

export default SearchTypeahead;